export default {"src":"/_next/static/media/WhoWeAre_025A.482f0325.JPG","height":684,"width":1920};